module.exports = __webpack_public_path__ + "static/media/css.fbacd7fe.svg";